import { Injectable } from '@angular/core';
// import { HttpClient } from '@angular/common/http';

@Injectable()
export class RemoteLoggingService {
  // public logginUrl = 'logging/url';

  // constructor(public http: Http) { }
  constructor() {}

  write(message: string) {
    // console.error(message);
  }
}
